import { Blog } from 'almanac-ui/icons/blaze/32'
import { object, string } from 'yup'
import { FormSchema } from '../Wizard/Form/Types'
import { includeImages } from './shared/includeImages'
import { brandVoiceId, tone } from './shared/voiceTones'
import { safify } from './utils/safify'
import { GenerationType } from 'components/BlazeCommandLine/api/createDocGenerationRequest'
import { topic } from 'components/Wizards/schemas/shared/topic'
import { BlogPostLength } from 'components/Wizards/BlogPostWizard/Types'
import { callToAction } from 'components/Wizards/schemas/shared/callToAction'
import { avoid } from 'components/Wizards/schemas/shared/avoid'
import { additionalInfo } from 'components/Wizards/schemas/shared/additionalInfo'
import { productDescription } from 'components/Wizards/schemas/shared/productDescription'
import * as yup from 'yup'
import { brandKitId } from './shared/brandKitId'
import { language } from './shared/language'
import { ChannelType } from 'components/CampaignCreationModal/Types'

import { wordpressExternalIntegrationId } from './shared/externalIntegrationId'

const meta = {
  icon: Blog,
  type: GenerationType.SEOPlanning,
  channel: ChannelType.BlogPost,
  previewUrl:
    'https://res.cloudinary.com/almanac/image/upload/v1710183787/Home%20Card%20Previews/xfpedur3adlb5odloqfm.png',
}

const fields = {
  topic: topic.meta({ label: 'What would you like to write about?', generationType: meta.type }),
  search_term: string()
    .required()
    .default('')
    .meta({
      label: 'What search term would you like to rank for?',
      placeholder: 'Enter a search term...',
      autoFill: true,
    })
    .transform(safify),
  blog_length: string()
    .oneOf(Object.values(BlogPostLength))
    .default(BlogPostLength.Medium)
    .meta({ label: 'How long should the post be?', autoFill: true })
    .transform(safify),
  brand_voice_id: brandVoiceId,
  brand_kit_id: brandKitId,
  external_integration_id: wordpressExternalIntegrationId,
  language,
  include_images: includeImages.meta({
    description: 'An image will make your posts far more engaging and attention grabbing',
  }),
  filename: yup.string().default('').meta({ hide: true }).transform(safify),
  tone,
  call_to_action: callToAction.meta({ collapsible: true }),
  author_persona: string()
    .default('')
    .meta({
      label: 'Author Persona',
      placeholder: 'Who should the post be written as',
      snippets: true,
      autoFill: true,
      collapsible: true,
    })
    .transform(safify),
  product_description: productDescription.meta({ collapsible: true }),
  avoid: avoid.meta({ collapsible: true }),
  additional_info: additionalInfo.meta({ collapsible: true }),
}

export const SEOPlanningSchema = object(fields).meta(meta) as FormSchema<GenerationType>
